import React from "react"
import { connect } from "react-redux"
import {
  refresh,
  openPage,
  clear,
  startInventory,
  sort,
} from "../ducks/tabularData/inventories"
import { authorize } from "../decorators/authorize"
import requireStore from "../decorators/requireStore"
import { inventoriesPage, inventoryPage } from "../config/routesInfo"
import Info from "../components/Info"
import { Grid, Form, Checkbox, Button, Segment } from "semantic-ui-react"
import Pagination from "../components/Pagination"
import EditableTable from "../components/EditableTable"
import bind from "bind-decorator"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"

const columns = [
  {
    title: "ID",
    name: "id",
    dataType: "string",
  },
  {
    title: "supplyTitle",
    name: "title",
    dataType: "string",
    sortable: true,
  },
  {
    title: "employe",
    name: "login",
    dataType: "string",
    sortable: true,
  },
  {
    title: "dateStart",
    name: "startDate",
    dataType: "date",
    sortable: true,
  },
  {
    title: "dateEnd",
    name: "endDate",
    dataType: "date",
    sortable: true,
  },
]

@authorize(...inventoriesPage.permissions)
@requireStore()
@withTranslation()
@withRouter
@connect(
  (state) => ({
    activeFilters: state.inventories.filters,
    sortedBy: state.inventories.sortedBy,
    sortedAsc: state.inventories.sortedAsc,
    data: state.inventories.data,
    isLoading: state.inventories.pendingRequests > 0,
    pagesCount: state.inventories.totalPages,
    currentPage: state.inventories.currentPage,
    currentStoreId: state.profile.currentStore.id,
  }),
  (dispatch) => ({
    refresh: () => dispatch(refresh()),
    clear: () => dispatch(clear()),
    onPageSelect: (...data) => dispatch(openPage(...data)),
    onStart: (...data) => dispatch(startInventory(...data)),
    onSort: (...data) => dispatch(sort(...data)),
  }),
)
export default class InventoriesPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      title: "",
      nameVisible: true,
      nameEditable: true,
      priceVisible: true,
      priceEditable: true,
      quantityVisible: true,
      quantityEditable: true,
    }
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(newProps) {
    const { currentStoreId, refresh } = this.props
    if (newProps.currentStoreId !== currentStoreId) {
      refresh()
    }
  }

  componentDidMount() {
    this.props.refresh()
    const { onSort } = this.props
    onSort("startDate")
  }

  componentWillUnmount() {
    this.props.clear()
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  handleChange({}, { name, value, checked }) {
    this.setState({ [name]: checked || value })
  }

  @bind
  start() {
    if (this.props.isLoading) {
      return
    }
    const {
      title,
      nameVisible,
      nameEditable,
      priceEditable,
      priceVisible,
      quantityVisible,
      quantityEditable,
    } = this.state
    this.props.onStart({
      title,
      name: {
        visible: nameVisible,
        editable: nameEditable,
      },
      price: {
        visible: priceVisible,
        editable: priceEditable,
      },
      quantity: {
        visible: quantityVisible,
        editable: quantityEditable,
      },
    })
  }

  @bind
  openInventory({ inventoryId }) {
    this.props.history.push(inventoryPage.path + "/" + inventoryId)
  }

  render() {
    const {
      activeFilters,
      sortedBy,
      sortedAsc,
      data,
      isLoading,
      currentPage,
      pagesCount,
      onPageSelect,
      onSort,
      t,
    } = this.props
    const tableData = {
      columns,
      activeFilters,
      sortedBy,
      sortedAsc,
      data,
      isLoading,
      onSort,
    }
    const {
      title,
      nameVisible,
      nameEditable,
      priceEditable,
      priceVisible,
      quantityVisible,
      quantityEditable,
    } = this.state
    return (
      <div className="editable-table-holder">
        <h2>
          {t("inventoriesPage")}
          <Info
            text={
              <div>
                <p>{t("In this section you can")}</p>
                <ul>
                  <li>{t("Conduct a new inventory")}</li>
                  <li>{t("View details of previous inventories")}</li>
                </ul>
              </div>
            }
          />
        </h2>
        <Segment className="inventory-holder" loading={isLoading}>
          <Form.Input
            fluid
            placeholder={t("titelInventory")}
            name="title"
            value={title}
            onChange={this.handleChange}
          />
          <div className="inventory-checkbox-holder">
            {t("supplyTitle")}:
            <Checkbox
              label={t("show")}
              name="nameVisible"
              defaultChecked={nameVisible}
              onChange={this.handleChange}
              disabled
            />
            <Checkbox
              label={t("edit")}
              name="nameEditable"
              defaultChecked={nameEditable}
              onChange={this.handleChange}
            />
          </div>
          <div className="inventory-checkbox-holder">
            {t("priceSale2")}:
            <Checkbox
              label={t("show")}
              name="priceVisible"
              defaultChecked={priceVisible}
              onChange={this.handleChange}
              disabled
            />
            <Checkbox
              label={t("edit")}
              name="priceEditable"
              defaultChecked={priceEditable}
              onChange={this.handleChange}
            />
          </div>
          <div className="inventory-checkbox-holder">
            {t("quantity")}:
            <Checkbox
              label={t("show")}
              name="quantityVisible"
              defaultChecked={quantityVisible}
              onChange={this.handleChange}
              disabled
            />
            <Checkbox
              label={t("edit")}
              name="quantityEditable"
              defaultChecked={quantityEditable}
              onChange={this.handleChange}
            />
          </div>
          <br />
          <Button color="green" loading={isLoading} onClick={this.start}>
            {t("startInventory")}
          </Button>
        </Segment>
        <h2>{t("pastInventory")}</h2>
        <Grid>
          <Grid.Row verticalAlign="middle">
            <Grid.Column mobile={16} tablet={10} computer={8}>
              <Pagination
                max={4}
                count={pagesCount}
                current={currentPage}
                onSelect={onPageSelect}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <EditableTable
          title={t("inventoriesPage")}
          {...tableData}
          isLoading={isLoading}
          onSelect={this.openInventory}
          noOptions
        />
      </div>
    )
  }
}
